import { Injectable } from '@angular/core';
import crypto from 'crypto-js';

import { environment } from '@env/environment';

@Injectable()
export class CryptoService {
  private key = environment.crypto.key;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  private IV = environment.crypto.IV;

  encryptId(id: number): string {
    if (!id) {
      return null;
    }

    return this.encrypt(id, true)
      .replaceAll('/', '_')
      .replaceAll('=', '-')
      .replaceAll('+', '.');
  }

  decryptId(encryptedId: string): number {
    if (String.isNullOrWhiteSpace(encryptedId)) {
      return null;
    }

    const decrypted = this.decrypt(
      encryptedId.replaceAll('_', '/').replaceAll('-', '=').replaceAll('.', '+')
    );

    if (String.isNullOrWhiteSpace(decrypted) || isNaN(+decrypted)) {
      return 0;
    }

    return +decrypted;
  }

  //#region Private methods

  private encrypt(res: any, typeObj: boolean): string {
    const data = typeObj ? JSON.stringify(res) : res;
    const keyHex = crypto.enc.Utf8.parse(this.key);
    const iv = crypto.enc.Utf8.parse(this.IV);
    const mode = crypto.mode.CBC;
    const encrypted = crypto.DES.encrypt(data, keyHex, { iv, mode });
    return encrypted.toString();
  }

  private decrypt(encrypted: string): string {
    const keyHex = crypto.enc.Utf8.parse(this.key);
    const iv = crypto.enc.Utf8.parse(this.IV);
    const mode = crypto.mode.CBC;
    const decrypted = crypto.DES.decrypt(encrypted, keyHex, {
      iv,
      mode,
    });
    return decrypted.toString(crypto.enc.Utf8);
  }

  //#endregion
}
